import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=4bee6a36&scoped=true"
import script from "./classify.vue?vue&type=script&lang=js"
export * from "./classify.vue?vue&type=script&lang=js"
import style0 from "./classify.vue?vue&type=style&index=0&id=4bee6a36&prod&lang=scss"
import style1 from "./classify.vue?vue&type=style&index=1&id=4bee6a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee6a36",
  null
  
)

export default component.exports